/**
 * SVRS-49895 — Adobe Target A/B test "WWW AI ChatBot vs SMS ChatBot".
 *
 * - Control group ("SMS ChatBot") is shown the SMS text-consent checkbox.
 * - Challenger group ("WWW AI Chat") is NOT shown SMS consent and is instead
 *   shown the on-site WWW AI chatbot widget.
 *
 * IMPORTANT: this value must match the experience name configured for the
 * challenger variant in Adobe Target. Update it to the exact string used in
 * the Target activity before release.
 */
export const WWW_AI_CHAT_EXPERIENCE = 'www-ai-chat';

/**
 * True when the current visitor is bucketed into the WWW AI Chat challenger
 * experience of the SVRS-49895 Adobe Target test. Reads the active Target
 * activities off the Adobe data layer; defaults to `false` (control) when the
 * data layer or activities are unavailable.
 */
interface AdobeTargetActivity {
  experience?: { name?: string };
}

export function isWwwAiChatChallenger(): boolean {
  const dataLayer = (
    window as unknown as {
      adobeDataLayer?: {
        getState(key: string): AdobeTargetActivity[] | undefined;
      };
    }
  ).adobeDataLayer;
  const activities = dataLayer?.getState('target.activities') ?? [];
  return activities.some((a) => a?.experience?.name === WWW_AI_CHAT_EXPERIENCE);
}
